import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Video icon for representing video files
 */
export const VideoIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polygon points="23 7 16 12 23 17 23 7"></polygon>
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
    </Icon>
  );
};

export default VideoIcon;
